import { render, staticRenderFns } from "./List-Vehicle-Department.vue?vue&type=template&id=ed0759be"
import script from "./List-Vehicle-Department.vue?vue&type=script&lang=js"
export * from "./List-Vehicle-Department.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports